export const BlackFilledCircleSvg = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      style={{ borderRadius: '50%' }}
      {...props}
    >
      <g clipPath="url(#a)">
        <rect width="40" height="40" fill="#4C4C4C" rx="20" />
        <path
          stroke="#000"
          strokeWidth=".5"
          d="M0 10.04c20 .66 23.7 15.86 40 1.51M0 6.37c20 .65 23.7 15.86 40 1.5M0 13.73c20 .65 23.7 15.86 40 1.5M0 17.4c20 .66 23.7 15.87 40 1.51M0 21.07c20 .65 23.7 15.86 40 1.51m-40 4c20 .66 23.7 15.87 40 1.52M0 22.9c20 .66 23.7 15.87 40 1.52M0 30.26c20 .65 23.7 15.86 40 1.51M0 32.1c20 .65 23.7 15.86 40 1.5M0 35.79c20 .65 23.7 15.86 40 1.5M0 11.89c20 .65 23.7 15.86 40 1.51M0 33.94c20 .65 23.7 15.86 40 1.5M0 .86c20 .65 23.7 15.86 40 1.51M0-2.82c20 .65 23.7 15.86 40 1.5M0 4.54c20 .65 23.7 15.86 40 1.5M0-4.66C20-4 23.7 11.2 40-3.14M0 2.69c20 .65 23.7 15.86 40 1.51M0-.99C20-.33 23.7 14.88 40 .52M0 8.2c20 .66 23.7 15.87 40 1.51M0 19.23c20 .66 23.7 15.86 40 1.51M0 15.56c20 .65 23.7 15.86 40 1.5M0 28.43c20 .66 23.7 15.87 40 1.51M0-6.5c20 .65 23.7 15.86 40 1.51M0 24.75c20 .65 23.7 15.86 40 1.5"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="40" height="40" fill="#fff" rx="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
